import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { useDismissOnEscape } from './useDismissOnEscape';

interface ConfirmationDialogProps {
  isOpen: boolean;
  title?: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  isOpen,
  title = 'Confirm Action',
  message,
  onConfirm,
  onCancel,
}) => {
  const dismissRef = useDismissOnEscape(isOpen, onCancel);
  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog onClose={onCancel} className="relative z-[10050]">
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/30 backdrop-blur-sm" />
        </Transition.Child>

        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-200"
            enterFrom="scale-95 opacity-0"
            enterTo="scale-100 opacity-100"
            leave="ease-in duration-150"
            leaveFrom="scale-100 opacity-100"
            leaveTo="scale-95 opacity-0"
          >
            <Dialog.Panel ref={dismissRef} className="w-full max-w-sm rounded-lg bg-white p-6 shadow-xl">
              <Dialog.Title className="text-lg font-semibold text-gray-800">{title}</Dialog.Title>
              <Dialog.Description className="mt-2 text-sm text-gray-600">{message}</Dialog.Description>

              <div className="mt-4 flex justify-end gap-3">
                <button
                  className="px-4 py-1 text-sm rounded bg-gray-100 hover:bg-gray-200"
                  onClick={onCancel}
                >
                  Cancel
                </button>
                <button
                  className="px-4 py-1 text-sm text-white bg-red-600 hover:bg-red-700 rounded"
                  onClick={onConfirm}
                >
                  Confirm
                </button>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ConfirmationDialog;
